import type { InitPackageIdentifier } from './InitPackageIdentifier.js';
import type { GeneratedChange } from './GeneratedChange.js';

export interface GeneratedPackageChanges extends InitPackageIdentifier {
  changes: GeneratedChange[];
}
